module.exports = __webpack_public_path__ + "media/bootstrap-icons/signpost-fill-8d5d6a02.svg";